module.exports = {"title":"Forgotten password","resetPasswordButton":"Recover password","meta":"Reset password"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/recover.json
// module id = +gir
// module chunks = 1